import { render, staticRenderFns } from "./CreateAllowanceForCalendarCompleted.vue?vue&type=template&id=3f0565d6"
import script from "./CreateAllowanceForCalendarCompleted.vue?vue&type=script&lang=js"
export * from "./CreateAllowanceForCalendarCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports